import { Box, Modal } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';

import ModalStyle from '@/constants/ModalStyle';
import { slugify } from '../../../helper/slugify';
import { Link } from 'react-router-dom';
import ButtonCloseModal from '../../ui/Button/ButtonCloseModal';

export default function QRLink(props) {
	const { open, onClose, project } = props;
	const code = project.productprefix_detail ? project.productprefix_detail[0]?.productprefix : project.component_prefix_name || '';
	const number = project.productcodenumber || project.component_code_number;
	const id = project.componentid || project.productid;
	const name = project.productname || project.component_productname;
	const cUrl = window.location.origin + '/file/' + number + '/' + encodeURI(slugify(name.toLowerCase())) + '/' + id;
	const title = `${code} ${number} - ${name}`

	const onDownloadQR = () => {
		const canvas = document.getElementById('canvas-qr-download');
		if (!canvas) return;
		const image = canvas.toDataURL();
		let anchor = document.createElement('a');
		anchor.download = `${title} - QR-kode.png`;
		anchor.href = image;
		anchor.target = '_blank';
		anchor.click();
		anchor.remove();
	};

	return (
		<Modal open={open} onClose={onClose} aria-labelledby='modal-project-qr' aria-describedby='modal-project-qr' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25svh' }} className='relative flex flex-col gap-4 w-[90%] md:w-[680px] h-auto'>
				<span className='mb-4 text-2xl modal-title'>File: {`(${title})`}</span>
				<ButtonCloseModal onClose={onClose} />

				<hr />
				<div className='flex justify-center w-full h-auto'>
					<QRCodeCanvas size={180} marginSize={2} id='canvas-qr' value={cUrl} />
					<QRCodeCanvas className='hidden' size={171} marginSize={4} id='canvas-qr-download' value={cUrl} />
				</div>
				<div className='flex justify-center gap-12 mx-auto'>
					<Link className='text-bd-blue' to={cUrl} target='_blank' title='Link'>
						Link
					</Link>
					<button className='text-bd-blue' onClick={onDownloadQR}>
						Download QR
					</button>
				</div>
			</Box>
		</Modal>
	);
}
